import React from 'react';

const NumberAdjuster = ({ value, onDecrease, onIncrease, unit = '' }) => {
  return (
    <div className="flex items-center space-x-3">
      <button 
        className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center"
        onClick={onDecrease}
      >
        <i className="fa-solid fa-minus text-gray-500 text-xs"></i>
      </button>
      <span className="font-medium">{value}{unit}</span>
      <button 
        className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center"
        onClick={onIncrease}
      >
        <i className="fa-solid fa-plus text-gray-500 text-xs"></i>
      </button>
    </div>
  );
};

export default NumberAdjuster;